export default __webpack_public_path__ + "ffd976de06398a882d870ca167f92129.svg";